import React, { useState, useEffect } from 'react';
import './HeadMenu.scss';
import CallPopup from './tools/CallPopup'; 
import { useNavigate, useLocation } from 'react-router-dom'; 

const HeadMenu = ({ contactSectionId }) => {
  const [isSticky, setSticky] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Determine if the current path contains "/agent"
  const isAgentVersion = location.pathname.includes('/agent');

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  const navigateToAction = (event) => {
    event.preventDefault();

    if (isAgentVersion) {
      navigate('/agent/valuation'); // Navigate to agent valuation
    } else {
      const currentSearchParams = new URLSearchParams(location.search); // Use search params for ads
      const adVersion = currentSearchParams.get('ad');
      console.log('adVersion:', adVersion);

      if (adVersion === 'new') {
        navigate('/property_details?ad=new');
      } else {
        navigate('/property_details'); // Default behavior
      }
    }
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);

    const cookieBanner = document.getElementById('CookieNewDialog');
    if (!isPopupOpen) {
      if (cookieBanner) {
        cookieBanner.style.opacity = '0';
        cookieBanner.style.pointerEvents = 'none';
      }
    } else {
      if (cookieBanner) {
        cookieBanner.style.opacity = '1';
        cookieBanner.style.pointerEvents = 'auto';
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', () => setMenuOpen(false)); // Close menu on resize
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', () => setMenuOpen(false)); // Cleanup on unmount
    };
  }, []);

  return (
    <div className={`head-menu ${isSticky ? 'sticky' : ''}`}>
      <div className="head-menu-logo">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FMenu%20Logo%20-%20Your%20Move%20Newcastle%20and%20Sunderland.png?alt=media&token=d3be7022-6b1c-44f9-8ad4-bd38ce619322"
          alt="Logo"
        />
      </div>
      <div className="head-menu-right-section">
        <button className="head-menu-call-button" onClick={togglePopup}>
          Call Us
        </button>
        <button
          className="head-menu-contact-button"
          onClick={navigateToAction}
        >
          <span className="head-menu-button-text">
            {isAgentVersion ? 'Free Valuation' : 'Instant Valuation'}
          </span>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Farrow2.png?alt=media&token=6dc60e9a-3731-4de9-9888-a3a84809214a"
            alt="Arrow Icon"
            className="head-menu-arrow-icon"
          />
        </button>
      </div>
      <div className="burger-menu" onClick={toggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className={`mobile-menu ${isMenuOpen ? 'show' : ''}`}>
        <button
          className="head-menu-contact-button mobile-menu-button"
          onClick={(e) => {
            navigateToAction(e);
            setMenuOpen(false);
          }}
        >
          {isAgentVersion ? 'Free Valuation' : 'Instant Valuation'}
        </button>
        <button
          className="head-menu-call-button mobile-call-button"
          onClick={() => {
            togglePopup();
            setMenuOpen(false);
          }}
        >
          Call Us
        </button>
      </div>

      {/* Use the CallPopup component */}
      <CallPopup isPopupOpen={isPopupOpen} togglePopup={togglePopup} />
    </div>
  );
};

export default HeadMenu;
